angular.module('common').filter('newlineToBreak', function() {
  return function(text) {
    return text.replace(/\n/g, '<br/>');
  };
});
